var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUtilityCollectionDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271,
    height: 109,
    viewBox: "0 0 271 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M270.267 0.533325H20.1325L0.466675 24.5172V108.2H250.592L270.267 84.2161V0.533325Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1392 8.24304L18.9635 16.8074H246.851L253.973 8.24304H26.1392Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.472 30.3828H116.15L114.46 37.5978H125.781L127.472 30.3828Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.41 46.7198H123.731L125.421 39.5049H114.109L112.41 46.7198Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.288 47.3136L85.2715 30.3827H57.216L50.355 59.5754H60.5521L62.8181 49.9495L70.6053 59.6024H105.801L107.653 51.7217H93.2655L93.9219 48.9419H108.309L110.108 41.0162H95.7833L96.4307 38.2364H110.818L112.671 30.3557H88.0411L81.3959 58.5498L75.8387 51.6947H76.5851L81.288 47.3136ZM71.3966 46.1351L69.5263 43.823H64.2569L65.5607 38.2634H73.222L71.3966 46.1351Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3622 65.1711H25.7795L18.9095 94.3639H43.8267L48.5116 89.9737L54.3386 65.1711H51.3622ZM39.1329 86.4832H30.959L34.1242 73.0518H42.2891L39.1329 86.4832Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M170.949 65.1711L168.062 77.4779L165.212 73.9514L166.659 67.78H160.212L158.099 65.1621H146.454L146.463 65.1711H146.445L139.584 94.3638H149.781L154.349 74.923L159.223 80.9415H167.244L164.088 94.3638H174.285L181.146 65.1711H170.949Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M138.559 65.1711H115.566L108.705 94.3639H118.902L121.402 83.7033H128.272L125.763 94.3639H135.978L141.499 70.8927L138.559 65.1711ZM130.142 75.8317H123.272L123.929 73.0518H130.79L130.142 75.8317Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.246 83.7033L110.099 75.8317H95.7833L96.4307 73.0518H110.818L112.671 65.1711H88.0411L81.3959 93.3383L75.8387 86.4832H76.5851L81.261 82.102L85.2445 65.1711H57.216L50.355 94.3639H60.5521L62.8181 84.7379L70.6053 94.3908H105.801L107.653 86.5102H93.2655L93.9219 83.7303L108.246 83.7033ZM71.3786 80.9235L69.5083 78.6115H64.2569L65.5607 73.0518H73.222L71.3786 80.9235Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M187.872 86.4832L188.519 83.7033H202.889L204.741 75.8317H190.372L191.028 73.0518H205.397L207.25 65.1711H192.88H188.177H182.683L175.822 94.3639H184.347H186.019H200.389L202.232 86.4832H187.872Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M233.174 82.102L237.158 65.1711H209.084L202.223 94.3639H212.42L214.677 84.7379L222.491 94.3908H234.127L227.734 86.4832H228.48L233.174 82.102ZM223.283 80.9235L221.412 78.6115H216.161L217.474 73.0518H225.135L223.283 80.9235Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilityCollectionDefault);
export default __webpack_public_path__ + "static/media/utilityCollection_default.356386a60a8c9a8b840612da27981d94.svg";
export { ForwardRef as ReactComponent };